import api from '@/api';

const state = {
  users: [],
};

const getters = {
  getUserById: state => id => state.users.find(x => x.id === id),
};

const actions = {
  async getList({ commit }) {
    if (state.users.length > 0) {
      return;
    }
    const response = await api.get('Users/List');
    const sortedList = response.data.value;
    sortedList.sort((a, b) => a.user.displayName.localeCompare(b.user.displayName));
    commit('users', sortedList);
  },
};

const mutations = {
  users(state, payload) {
    state.users = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
